import { useQuery, QueryHookOptions } from "@apollo/client";
import gql from "graphql-tag";

export const GET_LEADERBOARD = gql`
  query getRankedLeaderboard($page: Int, $queueType: Int, $regionId: String!) {
    leaderboardPage(page: $page, queueType: $queueType, regionId: $regionId) {
      totalPlayerCount
      topPlayerMostPlayedChamp
      players {
        iconId
        losses
        lp
        overallRanking
        rank
        summonerLevel
        riotTagLine
        riotUserName
        tier
        wins
      }
    }
  }
`;

export interface LeaderboardPlayer {
  iconId: number;
  losses: number;
  lp: number;
  overallRanking: number;
  rank: string;
  summonerLevel: number;
  riotUserName: string;
  riotTagLine: string;
  tier: string;
  wins: number;
}

export interface LeaderboardPlayerPlus extends LeaderboardPlayer {
  profileURL: string;
  totalGamesPlayed: number;
  winRate: number;
  winRateColor: string;
  regionId?: string;
}

export interface LeaderboardData {
  leaderboardPage: {
    players: LeaderboardPlayer[];
    topPlayerMostPlayedChamp: number;
    totalPlayerCount: number;
  };
}

export function useLeaderboardPage(regionId: string, queueType: number, page: number, queryOptions: QueryHookOptions = {}) {
  return useQuery<LeaderboardData>(GET_LEADERBOARD, {
    ...queryOptions,
    variables: {
      page,
      queueType,
      regionId,
    },
  });
}
